import AuthActionTypes from 'store/modules/auth/constants';
import { ApplicationActions } from 'store/types';
import User from 'types/models/user';

import ActionTypes from './constants';
import { MyUserState } from './types';

export const initialState: MyUserState = null;

function myUserReducer(
  state: MyUserState = initialState,
  action: ApplicationActions
): MyUserState {
  switch (action.type) {
    case ActionTypes.MERGE_MY_USER:
      return { ...state, ...action.payload } as User;
    case AuthActionTypes.LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export default myUserReducer;
